import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { ErrorHandlerService } from "../../../../services/shared/error-handler.service";
import { ProjectsService } from "./../../../../services/projects/projects.service";
import { FineSettingsService } from "./fine-settings.service";

@Component({
  selector: "app-fines",
  templateUrl: "./fines.component.html",
  styleUrls: ["./fines.component.css"],
})
export class FinesComponent implements OnInit {
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));

  params = {
    project_id: null,
    rule_name: "",
  };

  data = [];

  projects_select = [];
  constructor(
    private router: Router,
    private fineSettingsService: FineSettingsService,
    private projectService: ProjectsService,
    private slimLoadingBarService: SlimLoadingBarService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  ngOnInit() {
    this.fetchData();
    this.getAllProjects();
  }

  getAllProjects() {
    this.projectService.getProjects(true).subscribe(
      (res: any) => {
        this.projects_select = res.data;
        //console.log(this.projects_select);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  fetchData() {
    this.fineSettingsService.getFines(this.params).subscribe(
      (res: any) => {
        this.data = res.data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  // changes
  search() {
    this.fetchData();
  }

  reset() {
    this.params.project_id = null;
    this.params.rule_name = "";
    this.fetchData();
  }

  // Upload
  import_payload = {
    file_name: "",
    file: "",
  };

  handleFileUpload(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      //console.log(file);
      this.import_payload.file_name = file.name;
      reader.onload = () => {
        this.import_payload = {
          file_name: file.name,
          file: (reader.result as any).split(",")[1],
        };
      };
    }
  }

  uploadFile(modal) {
    if (!(this.import_payload.file_name && this.import_payload.file)) {
      swal("you must choose an excel file", "", "error");
    } else {
      const payload = {
        file_name: this.import_payload.file_name,
        file: this.import_payload.file,
      };
      this.slimLoadingBarService.start();
      this.fineSettingsService.importFines(payload).subscribe(
        (data) => {
          this.reset();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );

      swal("imports successfully", "", "success");
      modal.close();
    }
  }

  exportRules() {
    this.fineSettingsService
      .getFines({ ...this.params, is_export: 1 })
      .subscribe(
        (res: any) => {
          if (res.url) window.open(res.url, "_blank");
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/financial-settings/components/fines/fines.component.ts